import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramFeatureFlagsAdmin } from "services";

import { GET_CARBON_PROGRAM_FEATURE_FLAGS } from "consts";

import { CarbonProgramFeatureFlagsResponse } from "models";

export const useGetCarbonProgramFeatureFlags = ({ programId }: { programId: string }) =>
  useQuery<CarbonProgramFeatureFlagsResponse[]>({
    queryKey: [GET_CARBON_PROGRAM_FEATURE_FLAGS, programId],
    queryFn: () => getCarbonProgramFeatureFlagsAdmin({ programId }),
    enabled: !!programId,
  });
